import TableSys from "../generic/TableSys";

export default function TableUsers({handleEdit, users, getUsers}) {

  const headCells = [
    { id: "name", numeric: false, label: "Nome", order: 1 },
    { id: "name_client", numeric: false, label: "Nome do cliente", order: 2 },
    { id: "cre_ativo", numeric: false, label: "Status",  order: 3 },
    { id: "status", numeric: false, label: "Alterar Status",  order: 4 },
    { id: "action_edit", numeric: false, label: "Editar",  order: 5 },

  ];

  return <TableSys idPage={1} header={headCells} dados={users} handleEdit={handleEdit} handleStatus={() => getUsers()}></TableSys>;
}
